/**
 * Outline SVG icon module.
 */
import * as React from "react";
/**
 * Truck (outline) SVG icon. Generated wrapper that forwards props to the root svg.
 *
 * @param {React.SVGProps<SVGSVGElement>} props SVG element props.
 * @returns {JSX.Element}
 */
const SvgTruck = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <g stroke="currentColor">
      <path d="M38.414 48.414a2 2 0 1 0-2.828-2.828 2 2 0 0 0 2.828 2.828ZM48.414 48.414a2 2 0 1 0-2.828-2.828 2 2 0 0 0 2.828 2.828Z" />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M43 46V36a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1m8-1a1 1 0 0 1-1 1h-3m4-1v-8a1 1 0 0 1 1-1h2.586a1 1 0 0 1 .707.293l3.414 3.414a1 1 0 0 1 .293.707V46a1 1 0 0 1-1 1h-1m-6-1a1 1 0 0 0 1 1h1m-10 0a2 2 0 0 0 4 0m-4 0a2 2 0 0 1 4 0m10 0a2 2 0 0 1-4 0m4 0a2 2 0 0 0-4 0"
      />
    </g>
  </svg>
);
export default SvgTruck;
